const OneClassSvmGamma = {
	SCALE: 'Scale',
	AUTO: 'Auto'
};

export default OneClassSvmGamma;
